import React, { useState, useEffect } from 'react';
import { State, City } from 'country-state-city';
import { SZType, Property, ZSections,NewProperty } from './APIUrls';
import { useSnackbar } from 'notistack';
import { validateAuthAndRedirect } from './ValidateLocalStorage';

// Get token safely
const getToken = () => {
    try {
        const tokenStr = localStorage.getItem('tcn');
        return tokenStr ? JSON.parse(tokenStr) : null;
    } catch (e) {
        console.error("Error parsing token:", e);
        return localStorage.getItem('tcn');
    }
};


const useStates = () => {
    const [states, setStates] = useState([]);
    useEffect(() => {
        const allStates = State.getStatesOfCountry("IN");
        const statenames = allStates.filter((state) => state.isoCode === "HR");
        statenames.unshift({ name: "Select", isoCode: "0" });
        setStates(statenames);
    }, []);
    return states;
};

const useCities = (stateCode) => {
    const [cities, setCities] = useState([]);
    useEffect(() => {
        if (!stateCode) {
            setCities([]);
            return;
        }
        const allCities = City.getCitiesOfState("IN", stateCode);
        allCities.unshift({ name: "Select", isoCode: "0" });
        setCities(allCities);
    }, [stateCode]);
    return cities;
}

const GetAllSZType = async () => {
    try {
        debugger
        const Token = getToken();
        if (!Token) {
            console.error('Token not found');
            return;
        }
        //debugger
        const response = await fetch(SZType + 'GetAllSZType', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Token}`
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            let filterdata = result.data.filter(item => item.IsActive == true);
            localStorage.setItem('SZTypeList', JSON.stringify(filterdata));
            return filterdata;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllZSection = async () => {
    try {
        const Token = getToken();
        if (!Token) {
            console.error('Token not found');
            return;
        }
        //debugger
        const response = await fetch(ZSections + 'GetAllZSections', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Token}`
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            let filterdata = result.data; //.filter(item => item.IsActive==true);
            localStorage.setItem('ZSectionsList', JSON.stringify(filterdata));
            return filterdata;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllAmenities = async () => {
    try {
        let amenities = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!amenities) {
            amenities = await GetAllSZType();

            amenities = amenities.filter(item => item.SectionId === 1);
            //amenities.unshift({ TypeName: "Select", TypeId: "0" });
            return amenities;
        }
        else {
            amenities = amenities.filter(item => item.SectionId === 1);
            //amenities.unshift({ TypeName: "Select", TypeId: "0" });
            return amenities;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllNearbyAmenities = async () => {
    try {
        let amenities = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!amenities) {
            amenities = await GetAllSZType();

            amenities = amenities.filter(item => item.SectionId === 16);
            //amenities.unshift({ TypeName: "Select", TypeId: "0" });
            return amenities;
        }
        else {
            amenities = amenities.filter(item => item.SectionId === 16);
            //amenities.unshift({ TypeName: "Select", TypeId: "0" });
            return amenities;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllPropertyStatus = async () => {
    try {

        let propertystatus = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!propertystatus) {
            propertystatus = await GetAllSZType();

            propertystatus = propertystatus.filter(item => item.SectionId === 2 && (item.TypeId == 36 || item.TypeId == 38 || item.TypeId == 73));
            propertystatus.unshift({ TypeName: "Select", TypeId: "0" });
            return propertystatus;
        }
        else {
            propertystatus = propertystatus.filter(item => item.SectionId === 2 && (item.TypeId == 36 || item.TypeId == 38 || item.TypeId == 73));
            propertystatus.unshift({ TypeName: "Select", TypeId: "0" });
            return propertystatus;
        }
    } catch (error) {
        console.log(error);
    }
};


const GetAllPropertyTypes = async (CommercialorResidentialId = 0, PropertyForRentLeaseorSell = 0) => {
    //Residential SectionId=11
    //Commercial SectionId=12
debugger;
    try {
       
        if (CommercialorResidentialId == 0) {
            propertytype.unshift({ TypeName: "Select", TypeId: "0" });
            return propertytype;
        }


        let propertytype = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!propertytype) {
            propertytype = await GetAllSZType();
        }

        if (CommercialorResidentialId == 11) {

            propertytype = propertytype.filter(item => item.SectionId === CommercialorResidentialId);
            propertytype.unshift({ TypeName: "Select", TypeId: "0" });
            return propertytype;
        }
        else if (CommercialorResidentialId == 12) {
            propertytype = propertytype.filter(item => item.SectionId === CommercialorResidentialId);
            propertytype.unshift({ TypeName: "Select", TypeId: "0" });
            return propertytype;
        }
        
    } catch (error) {
        console.log(error);
    }
};


const GetAllProjectTypes = async (ProjectTypeParentId) => {
    //Newprojects Residential TypeId=103
    //Newprojects Commercial TypeId=116
    debugger
    try {
        if (ProjectTypeParentId == 0) {
            propertytype.unshift({ TypeName: "Select", TypeId: "0" });
            return propertytype;
        }
        let propertytype = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!propertytype) {
            propertytype = await GetAllSZType();
        }
        if (ProjectTypeParentId == 103 || ProjectTypeParentId == 116) {

            propertytype = propertytype.filter(item => item.TableParentId == ProjectTypeParentId);
            propertytype.unshift({ TypeName: "Select", TypeId: "0" });
            return propertytype;
        }
        propertytype.unshift({ TypeName: "Select", TypeId: "0" });
        return propertytype;
    } catch (error) {
        console.log(error);
    }
};

const GetAllBooleanValues = async () => {

    try {

        let propertytype = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!propertytype) {
            propertytype = await GetAllSZType();
        }
        if (propertytype && propertytype.length > 0) {

            propertytype = propertytype.filter(item => item.SectionId == 14);
        }
        propertytype.unshift({ TypeName: "Select", TypeId: "0" });
        return propertytype;
    } catch (error) {
        console.log(error);
    }
};

const GetAllFacingDirections = async () => {
    try {
        let propertytype = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!propertytype) {
            propertytype = await GetAllSZType();
        }
        if (propertytype && propertytype.length > 0) {
            propertytype = propertytype.filter(item => item.SectionId == 15);
        }
        propertytype.unshift({ TypeName: "Select", TypeId: "0" });
        return propertytype;
    } catch (error) {
        console.log(error);
    }
};



// const GetAllPropertyTypes = async () => {
//     try {
//
//         let propertytype = JSON.parse(localStorage.getItem('SZTypeList'));
//         if (!propertytype) {
//             propertytype = await GetAllSZType();

//             propertytype = propertytype.filter(item => item.SectionId === 3);
//             propertytype.unshift({ TypeName: "Select", TypeId: "0" });
//             return propertytype;
//         }
//         else {
//             propertytype = propertytype.filter(item => item.SectionId === 3);
//             propertytype.unshift({ TypeName: "Select", TypeId: "0" });
//             return propertytype;
//         }
//     } catch (error) {
//         console.log(error);
//     }
// };

const GetAllNoofBedrooms = async () => {
    try {

        let bedrooms = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!bedrooms) {
            bedrooms = await GetAllSZType();

            bedrooms = bedrooms.filter(item => item.SectionId === 4);
            bedrooms.unshift({ TypeName: "Select", TypeId: "0" });
            return bedrooms;
        }
        else {
            bedrooms = bedrooms.filter(item => item.SectionId === 4);
            bedrooms.unshift({ TypeName: "Select", TypeId: "0" });
            return bedrooms;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllNoofBathrooms = async () => {
    try {
        let bathrooms = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!bathrooms) {
            bathrooms = await GetAllSZType();

            bathrooms = bathrooms.filter(item => item.SectionId === 5);
            bathrooms.unshift({ TypeName: "Select", TypeId: "0" });
            return bathrooms;
        }
        else {
            bathrooms = bathrooms.filter(item => item.SectionId === 5);
            bathrooms.unshift({ TypeName: "Select", TypeId: "0" });
            return bathrooms;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllConstructionStatus = async () => {
    try {
        let constructionStatus = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!constructionStatus) {
            constructionStatus = await GetAllSZType();

            constructionStatus = constructionStatus.filter(item => item.SectionId === 6);
            constructionStatus.unshift({ TypeName: "Select", TypeId: "0" });
            return constructionStatus;
        }
        else {
            constructionStatus = constructionStatus.filter(item => item.SectionId === 6);
            constructionStatus.unshift({ TypeName: "Select", TypeId: "0" });
            return constructionStatus;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllPostedBy = async () => {
    try {
        let postedBy = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!postedBy) {
            postedBy = await GetAllSZType();

            postedBy = postedBy.filter(item => item.SectionId === 7);
            postedBy.unshift({ TypeName: "Select", TypeId: "0" });
            return postedBy;
        }
        else {
            postedBy = postedBy.filter(item => item.SectionId === 7);
            postedBy.unshift({ TypeName: "Select", TypeId: "0" });
            return postedBy;
        }
    } catch (error) {
        console.log(error);
    }
};


//These proeprties label from SZType table where sectionid=8 and IsActive=true

// const GetAllPropertyLabel = async () => {
//     try {
//         let propertyLabel = JSON.parse(localStorage.getItem('SZTypeList'));
//         if (!propertyLabel) {
//             propertyLabel = await GetAllSZType();
//             propertyLabel = propertyLabel.filter(item => item.SectionId === 8);
//             propertyLabel.unshift({ TypeName: "Select", TypeId: "0" });
//             return propertyLabel;
//         }
//         else {
//             propertyLabel = propertyLabel.filter(item => item.SectionId === 8);
//             propertyLabel.unshift({ TypeName: "Select", TypeId: "0" });
//             return propertyLabel;
//         }
//     } catch (error) {
//         console.log(error);
//     }
// };


const GetAllPropertyLabel = async () => {
    try {
        let propertyLabel = JSON.parse(localStorage.getItem('ZSectionsList'));
        if (!propertyLabel) {
            propertyLabel = await GetAllZSection();
            propertyLabel = propertyLabel.filter(item => item.SectionId === 11 || item.SectionId === 12);
            propertyLabel.unshift({ SectionName: "Select", SectionId: "0" });
            return propertyLabel;
        }
        else {
            propertyLabel = propertyLabel.filter(item => item.SectionId === 11 || item.SectionId === 12);
            propertyLabel.unshift({ SectionName: "Select", SectionId: "0" });
            return propertyLabel;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllPropertyFor = async () => {
    try {
        let propertyfor = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!propertyfor) {
            propertyfor = await GetAllSZType();

            propertyfor = propertyfor.filter(item => item.SectionId === 9);
            propertyfor.unshift({ TypeName: "Select", TypeId: "0" });
            return propertyfor;
        }
        else {
            propertyfor = propertyfor.filter(item => item.SectionId === 9);
            propertyfor.unshift({ TypeName: "Select", TypeId: "0" });
            return propertyfor;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllFloorPlans = async () => {
    try {

        let bedrooms = JSON.parse(localStorage.getItem('SZTypeList'));
        if (!bedrooms) {
            bedrooms = await GetAllSZType();

            bedrooms = bedrooms.filter(item => item.SectionId === 10);
            bedrooms.unshift({ TypeName: "Select", TypeId: "0" });
            return bedrooms;
        }
        else {
            bedrooms = bedrooms.filter(item => item.SectionId === 10);
            bedrooms.unshift({ TypeName: "Select", TypeId: "0" });
            return bedrooms;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllProperties = async (enqueueSnackbar) => {

    try {
        const userId = localStorage.getItem("id");
        const Token = getToken();

        // Validate token and userId
        if (!Token || !userId || userId === '0') {
            if (enqueueSnackbar) {
                enqueueSnackbar('Authentication failed. Please login again.', { variant: 'error' });
            }
            localStorage.clear();
            window.location.href = '/';
            return;
        }

        const response = await fetch(NewProperty + "GetNewPropertyByVendorId/" + userId, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Token}`,
            },
            body: JSON.stringify({}),
        });

        if (!response.ok) {
            if (response.status === 401) {
                if (enqueueSnackbar) {
                    enqueueSnackbar('Unauthorized: Your session has expired. Please login again.', { variant: 'error' });
                }
                localStorage.clear();
                window.location.href = '/';
            }
            throw new Error(`Server error: ${response.status}`);
        }

        const text = await response.text();
        if (!text || text.trim() === "") {
            throw new Error("Server returned an empty response");
        }

        const result = JSON.parse(text);
        return result;
    } catch (error) {
        console.error("Error fetching properties:", error);
        if (enqueueSnackbar) {
            enqueueSnackbar("Error fetching properties. Please try again.", { variant: "error" });
        }
    }
};



const GetAllPropertyforWeb = async (enqueueSnackbar) => {

    try {
        
        const response = await fetch(Property + "GetAllPropertyforWeb", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({}),
        });

        debugger;
        if (!response.ok) {
            throw new Error(`Server error: ${response.status}`);
        }

        const text = await response.text();
        if (!text || text.trim() === "") {
            throw new Error("Server returned an empty response");
        }

        const result = JSON.parse(text);
        if (result.Message == "Success") {
            localStorage.setItem('AllPropertiesforWeb', JSON.stringify(result.data));
            localStorage.setItem('AllFeaturedPropertiesforWeb', JSON.stringify(result.data.filter(item => item.IsFeatured === true)));
            localStorage.setItem('TopandLatest8PropertiesforWeb', JSON.stringify(result.data.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn)).slice(0, 8)));
           
            return result.data;
        }
        throw new Error("Failed to retrieve property data");
    } catch (error) {
        console.error("Error fetching properties:", error);
        if (enqueueSnackbar) {
            enqueueSnackbar("Error fetching properties. Please try again.", { variant: "error" });
        }
    }
};




const useGetAllProperties = () => {
    const { enqueueSnackbar } = useSnackbar();
    return () => GetAllProperties(enqueueSnackbar);
};




export {
    useStates,
    useCities,
    useGetAllProperties,
    GetAllAmenities,
    GetAllNearbyAmenities,
    GetAllPropertyStatus,
    GetAllPropertyTypes,
    GetAllProjectTypes,
    GetAllNoofBedrooms,
    GetAllNoofBathrooms,
    GetAllConstructionStatus,
    GetAllPostedBy,
    GetAllPropertyLabel,
    GetAllPropertyFor,
    GetAllProperties,
    GetAllFloorPlans,
    GetAllBooleanValues,
    GetAllFacingDirections,
    GetAllPropertyforWeb
};

